import { Link } from "react-router-dom";

const HowWorksTwo = () => {
  return (
    <div className="how__work">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-12 col-sm-12 col-12 sm__mt--40 md__mt--40">
            <div className="content-left">
              <h2>Trade confidently with a platform you can trust</h2>
              <p>
                {/* Gain full control of your trades with simple tools, transparent pricing, and reliable support from The Pips. */}
                Gain full control of your trades with intuitive tools designed
                to simplify your workflow, transparent pricing that keeps every
                cost clear, and reliable support whenever you need guidance.
                With The Pips, you trade in a secure, stable environment built
                to help you make smarter decisions, stay ahead of market
                movements, and manage your portfolio with total confidence.
              </p>

              <Link
                className="slide__btn dg__btn"
                to={process.env.PUBLIC_URL + "/register"}
              >
                Register
              </Link>
            </div>
          </div>

          <div className="col-lg-6 col-md-12 col-sm-12 col-12">
            <div className="thumb-right">
              <img
                src={process.env.PUBLIC_URL + "/images/home/home4.png"}
                alt="computer images"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HowWorksTwo;
